<template>
    <banner :bgImage="bannerInfo.file || bgImage"  :title="bannerInfo.title" :subTitle="bannerInfo.desc"></banner>
    <div class="main-bg" v-if="status==0">
        <div class="brand-top" ref="brandContainer">
            <div class="brand-text">
                <div class="wrap">
                    <Ani class="brand-title font36" :class="locale == 'en-US'?'en':'MultiLine2'" ref="brandTitle" ID="ani-brand-title">
                        <p>{{story.title}}</p>
                        <p>{{story.subTitle}}</p>
                    </Ani>
                    <Ani class="brand-des font16 MultiLine2" ref="brandDes" ID="ani-brand-des">
                        <p>{{story.desc}}</p>
                    </Ani>
                </div>
            </div>
            <div class="brand-img">
                <img src="@/assets/images/about/brand-top.png" :alt="t('common.logoAlt')">
                <div class="brand-logo" ref="brandLogo">
                    <div class="logo-img" ref="logo">
                        <img src="@/assets/images/about/logo.svg" :alt="story.title || t('common.logoAlt')" />
                        <!-- <img class="pc" src="@/assets/images/about/logo.svg" />
                        <img class="mobile" src="@/assets/images/about/logo-mobile.svg" /> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="brand-bot" v-if="intro?.dataList?.length">
            <div class="wrap">
                <Ani class="box-title text-center">
                    <h2 class="box-h2 font36 color-f">{{intro.title}}</h2>
                </Ani>
                <Ani>
                    <ul class="brand-list list-style flex flex-wrap color-f">
                        <li v-for="(item, index) in intro?.dataList" :key="index">
                            <div class="brand-item flex align-center justify-between">
                                <div class="brand-text">
                                    <h3 class="brand-title font24 ellipsis">{{ item.title }}</h3>
                                    <div class="brand-con font16" :class="locale == 'en-US'?'MultiLine4':'MultiLine2'">
                                        <div class="brand-des" v-html="item.desc"></div>
                                    </div>
                                </div>
                                <div class="brand-icon flex-center">
                                    <el-image :src="item.icon" :alt="item.title" fit="cover">
                                        <template #error>
                                            <div class="image-viewer-slot image-slot">
                                               <el-icon size="36"><Picture  /></el-icon>
                                            </div>
                                        </template>
                                    </el-image>
                                </div>
                            </div>
                        </li>
                    </ul>
                </Ani>
            </div>
        </div>
    </div>
    <error :status="status" v-if="status>0"></error>
</template>
<script setup lang="ts">
    import { ref, onMounted, onUnmounted } from 'vue'
    import useServerRequest from '@/composables/useServerRequest'
    import type { configParams, configResponse,bannerConfig } from '~/types'
    import { Picture } from '@element-plus/icons-vue'
    import { handleApiResponse } from "@/utils/utils"
    import { useRoute } from 'vue-router'
    import gsap from 'gsap'
    import { ScrollTrigger } from 'gsap/ScrollTrigger'
    const config = useRuntimeConfig()
    const cmsurlStrategy = config?.public?.cmsStrategy

    // 2. 获取当前路由和语言
    const route = useRoute()
    import { useI18n } from 'vue-i18n'
    const { locale, t } = useI18n()

    // 3. 初始化响应式数据
    const bgImage = ref<string>(staticURL('/banner/brand-banner.webp'))
   
    const status = ref<number>(0)

    // 品牌logo
    // 注册GSAP插件
    const brandContainer = ref(null)
    const brandTitle = ref(null)
    const brandDes = ref(null)
    const brandLogo = ref(null)
    // 初始化动画
    const initAni = () => {
        if (!process.client) return;
        // 创建动画时间线
        // 背景图
        const brandBox = gsap.timeline({
            scrollTrigger: {
                trigger: brandContainer.value,
                pin: true,
                start: 'top top', // 当目标区域顶部到达视口顶部时开始
                end: '+=100%', // 当目标区域底部到达视口顶部时结束
                scrub: true, // 动画与滚动进度关联
                markers: false, // 调试时设为true可以查看触发点
            }
        })
        // brandBox.to(brandLogo.value,{
        //     duration: 2,
        //     scale:1,
        //     autoAlpha: 1,
        //     ease: 'power1.in'
        // })
        // brandBox.to(brandTitle.value,{
        //     duration: 1,
        //     y: '0',
        //     autoAlpha: 1,
        //     delay: 1,
        //     ease: 'power1.in'
        // })
        // .to(brandDes.value,{
        //     duration: 1,
        //     y: '0',
        //     autoAlpha: 1,
        //     ease: 'power1.in'
        // })
    }



    // 5. 配置信息
    //其他信息
    const seo = ref<configResponse['pageValue']['seo']>({
    title: '',
    keywords: '',
    desc: ''
})
    const bannerInfo = ref<bannerConfig>({})
    const intro = ref<configResponse['pageValue']['intro']>({
        title:'',
        dataList: []
    })
    const story = ref<configResponse['pageValue']['story']>({
         title: '',
         subTitle: '',
         desc: '',
         image: ''
    })
    const infoParams = ref<configParams>({
        pageCode: "BRAND_INTRO"
    })
    const getInfo = async () => {
        try {
            const { data } = await useServerRequest<configResponse>(
                'brand-info',
                `${cmsurlStrategy}/getPageConfig`,
                { method: 'GET', params: infoParams.value, language: locale.value }
            )
            const res = data?.value
            const result = handleApiResponse(res)
            if (!result.success) {
                status.value = result.status
                return
            }
            const getInfoData = data?.value?.data?.pageValue
            seo.value = getInfoData?.seo
            intro.value = getInfoData?.intro ||{
                title:'',
                dataList: []
            }
            story.value= getInfoData?.story || {
                title: '',
                subTitle: '',
                desc: '',
                image: ''
            }
            bannerInfo.value = getInfoData?.banner?.[0] || {}; // 链式判断 + 默认值
            
        } catch (error) {
            status.value = 2
        }
    }
    getInfo()
    useHead({
        title: () => seo?.value?.title || '', // 保持不变（已正确）
        meta: [
          { 
            name: 'keywords', 
            content: () => seo?.value?.keywords || '' // 改为函数形式！
          },
          { 
            name: 'description', 
            content: () => seo?.value?.desc || '' // 改为函数形式！（去掉多余的模板字符串）
          }
        ]
    })
    
    onMounted(() => {
        if (process.client) {
            gsap.registerPlugin(ScrollTrigger)
        }
        // 设置元素初始状态
        // gsap.set([brandTitle.value,brandDes.value], {
        //     y: '50%',
        //     opacity: 0
        // })
        // gsap.set(brandLogo.value, {
        //     scale: 2,
        //     opacity: 0
        // })
        // initAni()
    })
    
</script>
<style scoped lang="scss">
@use '@/assets/css/about.scss';
</style>